import { Modal, Typography } from '@smartgift/frontend-toolkit';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useRecogRecipientsBulkUpsert } from '@hero/services';

import { CustomizeMessageTable } from './CustomizeMessageTable';
import * as S from './style';

function RecognitionCustomizeMessageModal({ code, isOpen, setIsOpen, editable = true, ...props }) {
  const { t } = useTranslation();
  const [customMessages, setCustomMessages] = useState({});
  const { mutateAsync: recipientBulkUpsert } = useRecogRecipientsBulkUpsert();

  const customMessageLength = useMemo(() => {
    return Object.keys(customMessages).length;
  }, [customMessages]);

  const discardChanges = () => {
    setCustomMessages({});
    setIsOpen(false);
  };

  async function updateCustomizedRecipientMessages() {
    await recipientBulkUpsert({
      params: {
        code
      },
      body: {
        recipients: Object.keys(customMessages).map(email => ({
          email,
          experienceSettings: customMessages[email]
        }))
      }
    });

    setCustomMessages({});
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={discardChanges}
      title={t('customizeRecipientMessages')}
      size="lg"
      primaryButtonProps={{
        children: editable ? t('saveChanges') : t('close'),
        onClick: () => {
          if (editable) {
            if (updateCustomizedRecipientMessages) updateCustomizedRecipientMessages();
          }
          setIsOpen(false);
        },
        disabled: editable ? customMessageLength === 0 : false
      }}
      secondaryButtonProps={{
        children: editable && t('cancel')
      }}
    >
      <S.CustomizeMessageModal>
        {editable && (
          <Typography variant="body1Bold">{t('customizeRecipientMessagesSubTitle')}</Typography>
        )}
        <CustomizeMessageTable
          editable={editable}
          code={code}
          customMessages={customMessages}
          setCustomMessages={setCustomMessages}
          {...props}
        />
      </S.CustomizeMessageModal>
    </Modal>
  );
}

export { RecognitionCustomizeMessageModal };
